import React__default, { useMemo } from 'react';
import { ArticleByline } from './article-by-line.esm.js';
import { ArticleLeadMedia } from './article-lead-media.esm.js';
import { ArticleSocialShareButtons } from './article-share-options.esm.js';
import { ArticleSummary } from './article-summary.esm.js';
import { ArticlePageTitle } from './article-title.esm.js';
import { ArticleToolTip } from './article-tooltip.esm.js';

var ArticleLeadContent = function ArticleLeadContent(props) {
  var title = props.title,
    summary = props.summary,
    leadMedia = props.leadMedia,
    categoryBar = props.categoryBar,
    isVertical = props.isVertical,
    messages = props.messages,
    authorByline = props.authorByline,
    shareOptions = props.shareOptions,
    isMachineTranslation = props.isMachineTranslation;
  var leadMediaIsNotEmpty = leadMedia.image !== undefined || leadMedia.caption !== '' || leadMedia.videoId !== '' || leadMedia.embedCode !== '' || leadMedia.leadMediaGalleryContent !== undefined;
  var captionInnerHtml = useMemo(function () {
    var _leadMedia$caption;
    return {
      __html: (_leadMedia$caption = leadMedia.caption) !== null && _leadMedia$caption !== void 0 ? _leadMedia$caption : ''
    };
  }, [leadMedia.caption]);
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-lead-content",
    className: "grid gap-y-6"
  }, isVertical && !leadMedia.videoId && !leadMedia.embedCode && !leadMedia.leadMediaGalleryContent && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "csg-tw- flex-row border-b border-[#BFBFBF] md:flex"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col justify-between pr-[10px] md:w-2/4 md:text-center"
  }, categoryBar && /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-category-bar",
    className: "flex flex-col items-start font-sans font-normal text-action-primary hover:underline md:text-p-16"
  }, categoryBar), /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React__default.createElement(ArticlePageTitle, {
    title: title
  }), summary && /*#__PURE__*/React__default.createElement(ArticleSummary, {
    summary: summary,
    isVertical: isVertical
  })), /*#__PURE__*/React__default.createElement("div", null)), leadMediaIsNotEmpty && /*#__PURE__*/React__default.createElement(ArticleLeadMedia, {
    image: leadMedia.image,
    isVertical: isVertical
  })), leadMedia.caption && /*#__PURE__*/React__default.createElement("div", {
    className: "mt-[8px] flex flex-col self-stretch font-sans text-p-14 font-normal leading-normal text-[#757575] md:ml-[calc(50%+5px)] md:text-p-16 md:leading-6"
  }, /*#__PURE__*/React__default.createElement("figcaption", {
    "automation-id": "article-caption",
    id: "article-caption",
    dangerouslySetInnerHTML: captionInnerHtml
  }))), (!isVertical || isVertical && leadMedia.videoId || isVertical && leadMedia.embedCode) && /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-y-6"
  }, /*#__PURE__*/React__default.createElement("div", null, categoryBar && /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-category-bar",
    className: "font-sans text-p-12 font-medium leading-6 text-action-primary hover:underline md:text-p-16"
  }, categoryBar), /*#__PURE__*/React__default.createElement(ArticlePageTitle, {
    title: title
  }), summary && /*#__PURE__*/React__default.createElement(ArticleSummary, {
    summary: summary
  })), leadMediaIsNotEmpty && /*#__PURE__*/React__default.createElement(ArticleLeadMedia, {
    image: leadMedia.image,
    caption: leadMedia.caption,
    videoId: leadMedia.videoId,
    embedCode: leadMedia.embedCode,
    leadMediaGalleryContent: leadMedia.leadMediaGalleryContent
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/React__default.createElement(ArticleByline, {
    bylineElement: authorByline.bylineElement,
    affiliation: authorByline.affiliation
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "items-center"
  }, shareOptions && /*#__PURE__*/React__default.createElement(ArticleSocialShareButtons, {
    shareOptions: shareOptions
  }))), isMachineTranslation && messages && /*#__PURE__*/React__default.createElement("div", {
    className: "font-sans text-p-16"
  }, /*#__PURE__*/React__default.createElement(ArticleToolTip, {
    translatedFromText: messages.translatedFromText,
    tooltipText: messages.tooltipText,
    promoLabel: messages.promoLabel
  })));
};

export { ArticleLeadContent };
//# sourceMappingURL=article-lead-content.esm.js.map
